import { useBreakpoints } from '@/core/hooks/useBreakpoints/useBreakpoints'
import { CustomDrawer } from '@atbay/cyber-components'
import { FC, PropsWithChildren } from 'react'

interface DrawerProps extends PropsWithChildren {
    onClose: () => void
    onBack?: () => void
    isOpen: boolean
    width?: string
    header?: JSX.Element
    className?: string
}

const Drawer: FC<DrawerProps> = ({
    onClose,
    onBack,
    isOpen,
    width,
    header,
    className,
    children,
}) => {
    const { belowBreakpoint } = useBreakpoints()
    const resolveWidth = (): string => {
        if (width) return width
        if (belowBreakpoint('xl')) return '60vw'
        if (belowBreakpoint('xxl')) return '55vw'
        return '45vw'
    }
    const resolvedWidth = resolveWidth()

    return (
        <CustomDrawer
            anchor="right"
            open={isOpen}
            onClose={onClose}
            onBack={onBack}
            width={resolvedWidth}
            transitionDuration={400}
            header={header}
            className={className}
        >
            {children}
        </CustomDrawer>
    )
}

export default Drawer
